import { DropdownButton } from '.';

import type { DropdownButtonInterface } from './DropdownButton';

interface Props extends DropdownButtonInterface {
  href: string;
}

const DropdownLink = ({ href, ...props }: Props) => {
  return <DropdownButton href={href} {...props} />;
};

export default DropdownLink;
